export default __webpack_public_path__ + "static/media/nr.e40b9e0c.svg";